import { httpClient } from "../../../shared/lib/api";

const EXPORT_URL = "report/response-classification/export/";

export async function exportResponseClassifications(
	filters: URLSearchParams,
): Promise<Blob> {
	const query = filters.toString();
	const url = query ? `${EXPORT_URL}?${query}` : EXPORT_URL;
	const response = await httpClient.get<Blob>(url, { responseType: "blob" });
	return response.data;
}
